




function csDetectScreen(env) {
  const e = env || {
    ua: navigator.userAgent || '',
    touch: navigator.maxTouchPoints || 0,
    short: Math.min(window.screen.width, window.screen.height),
  };
  const bySize = () => (Number.isFinite(e.short) && e.short > 0 ? (e.short < 600 ? 'phone' : 'tablet') : '');
  if (/iPhone|iPod/.test(e.ua)) return 'phone';
  if (/iPad/.test(e.ua)) return 'tablet';
  if (/Macintosh|Mac OS X/.test(e.ua)) return e.touch > 1 ? 'tablet' : 'desktop';
  if (/Android/.test(e.ua)) return bySize();
  if (/Windows|CrOS/.test(e.ua)) return 'desktop';
  if (/Linux|X11/.test(e.ua)) return e.touch > 0 ? '' : 'desktop';
  return '';
}

class CsWallpaperPage extends HTMLElement {
  connectedCallback() {
    this.#pickDownloads();
    

    this.onScreenChange = () => {
      clearTimeout(this.screenTimer);
      this.screenTimer = setTimeout(() => this.#pickDownloads(), 150);
    };
    window.addEventListener('resize', this.onScreenChange);
    window.addEventListener('orientationchange', this.onScreenChange);
    this.onChoice = (event) => this.#rememberChoice(event);
    this.addEventListener('click', this.onChoice);
    this.bar = this.querySelector('[data-cswm-bar]');
    this.links = [...this.querySelectorAll('[data-cswm-room-link]')];
    const hero = this.querySelector('[data-cswm-hero]');
    if (this.bar && hero) {
      this.heroObserver = new IntersectionObserver(([entry]) => {
        this.bar.classList.toggle('is-stuck', !entry.isIntersecting);
      });
      this.heroObserver.observe(hero);
    }
    this.#setCurrent(window.matchMedia('(min-width: 768px)').matches ? 'desktop' : 'phone');
    this.roomObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) this.#setCurrent(entry.target.dataset.cswmRoom);
      }
    }, { rootMargin: '-45% 0px -50% 0px' });
    for (const room of this.querySelectorAll('[data-cswm-room]')) this.roomObserver.observe(room);
    this.#showCurrentMonth();
  }

   
  #showCurrentMonth() {
    const rail = this.querySelector('[data-cswm-rail]');
    const current = rail?.querySelector('[aria-current="page"]');
    if (!rail || !current) return;
    const item = current.closest('li');
    const target = item.offsetLeft - rail.offsetLeft - (rail.clientWidth - item.offsetWidth) / 2;
    rail.scrollLeft = Math.max(0, target);
  }

   
  #pickDownloads() {
    let screen = '';
    try {
      screen = csDetectScreen();
    } catch (error) {
      screen = '';
    }
    if (this.picked && screen === this.screen) return;
    this.picked = true;
    this.screen = screen;
    for (const group of this.querySelectorAll('[data-cswm-dl]')) {
      group.classList.remove('is-picked');
      for (const item of group.querySelectorAll('.is-mine')) item.classList.remove('is-mine');
      const mine = screen && group.querySelector(`[data-cswm-screen="${screen}"]`);
      if (!mine) continue;
      group.classList.add('is-picked');
      mine.classList.add('is-mine');
    }
    this.#updateBar();
  }

  

  #rememberChoice(event) {
    const link = event.target.closest('[data-cswm-screen], [data-cswm-vdl]');
    const key = link?.dataset.cswmScreen || link?.dataset.cswmVdl;
    if (!key || key === this.chosen) return;
    this.chosen = key;
    this.#updateBar();
  }

  #updateBar() {
    const get = this.querySelector('[data-cswm-bar-get]');
    if (!get) return;
    const long = get.querySelector('[data-cswm-bar-long]');
    const short = get.querySelector('[data-cswm-bar-short]');
    if (!this.barDefault) {
      this.barDefault = { href: get.getAttribute('href'), aria: get.getAttribute('aria-label'), text: long.textContent };
    }
    const key = this.chosen || this.screen;
    const item = key && this.querySelector(`[data-cswm-dl] [data-cswm-screen="${key}"]`);
    if (!item) {
      get.setAttribute('href', this.barDefault.href);
      get.setAttribute('aria-label', this.barDefault.aria);
      get.removeAttribute('rel');
      long.textContent = this.barDefault.text;
      short.textContent = this.barDefault.text;
      return;
    }
    const name = item.dataset.cswmName || '';
    get.href = item.href;
    get.setAttribute('rel', 'noopener');
    get.setAttribute('aria-label', (get.dataset.aria || '').replace('[screen]', name));
    long.textContent = (get.dataset.long || '').replace('[screen]', name);
    short.textContent = name;
  }

  disconnectedCallback() {
    this.heroObserver?.disconnect();
    this.roomObserver?.disconnect();
    window.removeEventListener('resize', this.onScreenChange);
    window.removeEventListener('orientationchange', this.onScreenChange);
    this.removeEventListener('click', this.onChoice);
    clearTimeout(this.screenTimer);
  }

  #setCurrent(room) {
    for (const link of this.links) {
      if (link.dataset.cswmRoomLink === room) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    }
  }
}

class CsWallpaperViewer extends HTMLElement {
  #items = [];
  #index = 0;
  #format = '';
  #trigger = null;
  #zoomed = false;
  #touchX = null;
  #touchT = 0;
  #lastTap = 0;
  #lastPointer = 'mouse';

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.img = this.querySelector('[data-cswm-img]');
    this.film = this.querySelector('[data-cswm-film]');
    this.stage = this.querySelector('[data-cswm-stage]');
    this.count = this.querySelector('[data-cswm-count]');
    this.fmt = this.querySelector('[data-cswm-fmt]');
    this.live = this.querySelector('[data-cswm-live]');
    if (!this.dialog || !this.img) return;

    const scope = this.closest('cs-wallpaper-page') || document;
    for (const tile of scope.querySelectorAll('[data-cswm-open]')) {
      tile.addEventListener('click', () => this.open(tile));
    }
    this.querySelector('[data-cswm-prev]')?.addEventListener('click', () => this.#go(-1));
    this.querySelector('[data-cswm-next]')?.addEventListener('click', () => this.#go(1));
    this.querySelector('[data-cswm-close]')?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('close', () => {
      this.#zoom(false);
      this.#trigger?.focus();
    });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); this.#go(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.#go(-1); }
    });
    

    this.img.addEventListener('dblclick', (event) => { if (this.#lastPointer === 'mouse') this.#zoomAt(event); });
    this.stage.addEventListener('click', (event) => { if (event.target === this.stage) this.dialog.close(); });
    this.stage.addEventListener('pointerdown', (event) => {
      this.#lastPointer = event.pointerType;
      if (event.pointerType === 'mouse') return;
      this.#touchX = event.clientX;
      this.#touchT = Date.now();
    });
    this.stage.addEventListener('pointerup', (event) => this.#onPointerUp(event));
  }

  open(tile) {
    const format = tile.dataset.cswmFormat;
    if (format !== this.#format) {
      this.#format = format;
      this.#items = [...(this.closest('cs-wallpaper-page') || document).querySelectorAll(`[data-cswm-open][data-cswm-format="${format}"]`)];
      this.#buildFilm();
    }
    this.#showDownloads(format);
    this.#index = this.#items.indexOf(tile);
    this.#trigger = tile;
    this.dialog.showModal();
    this.#render();
  }

  

  #showDownloads(format) {
    const links = [...this.querySelectorAll('[data-cswm-vdl]')];
    if (!links.length) return;
    const page = this.closest('cs-wallpaper-page');
    const screen = page?.screen || '';
    let main = 'desktop';
    if (format !== 'desktop') {
      main = screen === 'tablet' ? 'tablet' : 'phone';
      if (page?.chosen === 'phone' || page?.chosen === 'tablet') main = page.chosen;
    }
    const fits = (link) => (format === 'desktop') === (link.dataset.cswmVdl === 'desktop');
    if (!links.some((link) => link.dataset.cswmVdl === main)) main = (links.find(fits) || links[0]).dataset.cswmVdl;
    const anyFits = links.some(fits);
    for (const link of links) {
      const kind = link.dataset.cswmVdl;
       
      link.hidden = anyFits ? !fits(link) : kind !== main;
      link.className = kind === main ? 'btn btn--primary cswm-vdl__btn' : 'cswm-vdl__link';
    }
  }

  #buildFilm() {
    this.film.replaceChildren();
    this.#items.forEach((tile, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cswm-viewer__thumb';
      button.setAttribute('aria-label', tile.getAttribute('aria-label') || '');
      const thumb = document.createElement('img');
      thumb.src = tile.dataset.cswmThumb;
      thumb.alt = '';
      thumb.loading = 'lazy';
      button.append(thumb);
      button.addEventListener('click', () => { this.#index = i; this.#render(); });
      this.film.append(button);
    });
  }

  #render() {
    const tile = this.#items[this.#index];
    if (!tile) return;
    this.#zoom(false);
    const preview = tile.querySelector('img');
    this.img.width = Number(preview?.getAttribute('width')) || 1600;
    this.img.height = Number(preview?.getAttribute('height')) || 900;
    this.img.src = tile.dataset.cswmFull;
    this.img.alt = preview?.alt || '';
    const total = this.#items.length;
    this.count.textContent = `${this.#index + 1} / ${total}`;
    this.fmt.textContent = tile.dataset.cswmFormatLabel || '';
    this.live.textContent = `${this.#index + 1} / ${total}`;
    [...this.film.children].forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === this.#index)));
    this.film.children[this.#index]?.scrollIntoView({ block: 'nearest', inline: 'center' });
    for (const step of [1, -1]) {
      const next = this.#items[(this.#index + step + total) % total];
      if (next) new Image().src = next.dataset.cswmFull;
    }
  }

  #go(step) {
    const total = this.#items.length;
    if (!total) return;
    this.#index = (this.#index + step + total) % total;
    this.#render();
  }

  #zoom(on, x = 50, y = 50) {
    this.#zoomed = on;
    this.img.style.transformOrigin = `${x}% ${y}%`;
    this.img.classList.toggle('is-zoomed', on);
  }

  #zoomAt(event) {
    const box = this.img.getBoundingClientRect();
    this.#zoom(!this.#zoomed, ((event.clientX - box.left) / box.width) * 100, ((event.clientY - box.top) / box.height) * 100);
  }

  #onPointerUp(event) {
    if (this.#touchX === null) return;
    const dx = event.clientX - this.#touchX;
    const dt = Math.max(1, Date.now() - this.#touchT);
    this.#touchX = null;
    if (!this.#zoomed && (Math.abs(dx) > 50 || Math.abs(dx) / dt > 0.4)) {
      this.#go(dx < 0 ? 1 : -1);
      return;
    }
    if (Math.abs(dx) < 8 && event.target === this.img) {
      const now = Date.now();
      if (now - this.#lastTap < 300) this.#zoomAt(event);
      this.#lastTap = now;
    }
  }
}



class CsMonthSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-cswm-track]');
    this.arrows = [...this.querySelectorAll('[data-dir]')];
    if (!this.track) return;
    this.items = [...this.track.children];
    this.openLink = this.querySelector('[data-cswm-spot-link]');
    this.openText = this.querySelector('[data-cswm-open-text]');
    this.index = Math.max(0, this.items.findIndex((item) => item.querySelector('[aria-current="page"]')));
    this.onScroll = () => {
      if (!this.frame) this.frame = requestAnimationFrame(() => this.#sync());
    };
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    for (const arrow of this.arrows) arrow.addEventListener('click', () => this.#go(this.index + Number(arrow.dataset.dir)));
    this.onLoad = () => this.#go(this.index, true);
    this.#go(this.index, true);
     
    if (document.readyState !== 'complete') window.addEventListener('load', this.onLoad, { once: true });
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('load', this.onLoad);
    if (this.frame) cancelAnimationFrame(this.frame);
    clearTimeout(this.settle);
  }

  #offset(item) {
    const box = this.track.getBoundingClientRect();
    const r = item.getBoundingClientRect();
    return r.left + r.width / 2 - (box.left + box.width / 2);
  }

  #go(index, instant = false) {
    const i = Math.max(0, Math.min(this.items.length - 1, index));
    this.#focus(i);
    const still = instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
     
    this.moving = !still;
    clearTimeout(this.settle);
    if (this.moving) this.settle = setTimeout(() => { this.moving = false; this.#sync(); }, 500);
    this.track.scrollTo({ left: this.track.scrollLeft + this.#offset(this.items[i]), behavior: still ? 'instant' : 'smooth' });
  }

  #sync() {
    this.frame = 0;
    if (this.moving) return;
    let nearest = this.index;
    let best = Infinity;
    this.items.forEach((item, i) => {
      const d = Math.abs(this.#offset(item));
      if (d < best) { best = d; nearest = i; }
    });
    if (nearest !== this.index) this.#focus(nearest);
  }

  #focus(i) {
    this.index = i;
    this.items.forEach((item, k) => item.classList.toggle('is-spot', k === i));
    const [newer, older] = this.arrows;
    if (newer) newer.disabled = i === 0;
    if (older) older.disabled = i === this.items.length - 1;
    const link = this.items[i]?.querySelector('a');
    if (!this.openLink || !link) return;
    const own = link.getAttribute('aria-current') === 'page';
    this.openLink.hidden = own;
    if (own) return;
    this.openLink.href = link.getAttribute('href');
    this.openText.textContent = (this.openLink.dataset.template || '[month]').replace('[month]', link.dataset.cswmTitle || link.textContent.trim());
  }
}

if (!customElements.get('cs-wallpaper-page')) customElements.define('cs-wallpaper-page', CsWallpaperPage);
if (!customElements.get('cs-month-slider')) customElements.define('cs-month-slider', CsMonthSlider);
if (!customElements.get('cs-wallpaper-viewer')) customElements.define('cs-wallpaper-viewer', CsWallpaperViewer);
